<div *ngIf="isVisible" class="modal-overlay" (click)="onCancel()">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <div class="modal-header">
            <h4 class="modal-title bigTitleCol">{{ 'ADD_STUDENT.PREVIEW.TITLE' | translate }}</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
        </div>
        
        <div class="modal-body">
            <p class="text-muted">{{ 'ADD_STUDENT.PREVIEW.INSTRUCTION' | translate }}</p>
            <div class="mt-3 text-center mb-2" id="">
                {{ 'ADD_STUDENT.PART_A.ACCORDION_TITLE' | translate }}
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.PHOTO_LABEL' | translate }}：{{ previewData['photo']?.name }}</div>
            </div>

            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.NAME_ZH_LABEL' | translate }}：{{ previewData['chi_name'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.NAME_EN_LABEL' | translate }}：{{ previewData['eng_name'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.ALIAS_LABEL' | translate }}：{{ previewData['other_name'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.BIRTH_DATE_LABEL' | translate }}：{{ previewData['birth'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.NATIONALITY_LABEL' | translate }}：
                    {{
                        previewData['nationality'] === 'OTHER' 
                        ? previewData['other_nationality'] 
                        : ('NATIONALITIES.' + previewData['nationality'] | translate)
                    }}
                </div>
                
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.GENDER_LABEL' | translate }}：
                  {{ (previewData['gender'] === 'Male' ? ('ADD_STUDENT.PART_A.GENDER_OPTION_MALE' | translate) : (previewData['gender'] === 'Female' ? ('ADD_STUDENT.PART_A.GENDER_OPTION_FEMALE' | translate) : '')) }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.STUDENT_EMAIL_LABEL' | translate }}：{{ previewData['email'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.AGE_LABEL' | translate }}：{{ previewData['age'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.WEIGHT_LABEL' | translate }}：{{ previewData['weight'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.HEIGHT_LABEL' | translate }}：{{ previewData['height'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.HEAD_CIRCUMFERENCE_LABEL' | translate }}：{{ previewData['head_size'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.DIAGNOSIS_LABEL' | translate }}：{{ previewData['diagnosis'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.GUARDIAN_NAME_LABEL' | translate }}：{{ previewData['parent_name'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.RELATIONSHIP_LABEL' | translate }}：{{ previewData['parent_relationship'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.MOBILE_NO_LABEL' | translate }}：{{ previewData['parent_mobile'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.EMAIL_LABEL' | translate }}：{{ previewData['parent_email'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.HOME_NO_LABEL' | translate }}：{{ previewData['parent_home'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.CORRESPONDENCE_ADDRESS_LABEL' | translate }}：{{ previewData['parent_address'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.EMERGENCY_CONTACT_PERSON_LABEL' | translate }}：{{ previewData['emergency_person'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.EMERGENCY_MOBILE_NO_LABEL' | translate }}：{{ previewData['emergency_mobile'] }}</div>
            </div>

            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.OTHER_THERAPY_LABEL' | translate }}：{{ previewData['other_therapy'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.MEDICATION_LABEL' | translate }}：{{ previewData['medication'] }}</div>
            </div>

            <!-- <div class="row gx-0 text-secondary-purple" >
                <p><b>{{ 'ADD_STUDENT.PART_A.SCHOOL_INFO_TITLE' | translate }}</b></p>
            </div> -->
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.SCHOOL_NAME_LABEL' | translate }}：{{ previewData['school_name'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.SCHOOL_ADDRESS_LABEL' | translate }}：{{ previewData['school_address'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.SCHOOL_CONTACT_PERSON_LABEL' | translate }}：{{ previewData['school_contact_person'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.SCHOOL_TELEPHONE_LABEL' | translate }}：{{ previewData['school_tel'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.SCHOOL_FAX_LABEL' | translate }}：{{ previewData['school_fax'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.SCHOOL_EMAIL_LABEL' | translate }}：{{ previewData['school_email'] }}</div>
            </div>

            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_A.RIDING_EXPERIENCE_TITLE' | translate }}：{{ previewData['riding_experience'] }}</div>
            </div>

            <div class="mt-3 text-center" id="">
                {{ 'ADD_STUDENT.PART_B.ACCORDION_TITLE' | translate }}
            </div>
            <div class=" mb-2 text-muted " style="font-size: 12px;" id="">
                {{ 'ADD_STUDENT.PART_B.ASSESSOR_INSTRUCTION' | translate }}
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ASSESSOR_NAME_LABEL' | translate }}：{{ previewData['assessor_name'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ASSESSOR_PROFESSION_LABEL' | translate }}：{{ previewData['assessor_profession'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ASSESSOR_TELEPHONE_LABEL' | translate }}：{{ previewData['assessor_tel'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ASSESSMENT_DATE_LABEL' | translate }}：{{ previewData['assessment_date'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ASSESSOR_EMAIL_LABEL' | translate }}：{{ previewData['assessor_email'] }}</div>
            </div>
           
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.AUTISM_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['asd']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['asd_remark'] !== null && previewData['asd_remark'] !== undefined && previewData['asd_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['asd_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ADHD_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['adhd']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['adhd_remark'] !== null && previewData['adhd_remark'] !== undefined && previewData['adhd_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['adhd_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.SLD_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['sld']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['sld_remark'] !== null && previewData['sld_remark'] !== undefined && previewData['sld_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['sld_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.ID_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['ind']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['ind_remark'] !== null && previewData['ind_remark'] !== undefined && previewData['ind_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['ind_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.CD_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['comd']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['comd_remark'] !== null && previewData['comd_remark'] !== undefined && previewData['comd_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['comd_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.VI_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['visi']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['visi_remark'] !== null && previewData['visi_remark'] !== undefined && previewData['visi_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['visi_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.HI_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['heari']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['heari_remark'] !== null && previewData['heari_remark'] !== undefined && previewData['heari_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['heari_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.BED_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['bed']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['bed_remark'] !== null && previewData['bed_remark'] !== undefined && previewData['bed_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['bed_remark'] }}</div>
            </div>
            
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.PD_LABEL' | translate }}：
                  {{ getTranslatedSeverity(previewData['phyd']) }}
                </div>
            </div>
            <div class="row gx-0" *ngIf="previewData['phyd_remark'] !== null && previewData['phyd_remark'] !== undefined && previewData['phyd_remark'] !== ''">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}：{{ previewData['phyd_remark'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.OTHERS_LABEL' | translate }}：{{ previewData['others'] }}</div>
            </div>
            
            <!-- <div class="row gx-0 text-secondary-purple" >
                <p><b>{{ 'ADD_STUDENT.PART_B.MOBILITY_TITLE' | translate }}</b></p>
            </div> -->
            <div class="row gx-0">
                <div class="col-sm-12">
                    <p>{{ 'ADD_STUDENT.PART_B.AMBULATORY_TITLE' | translate }}</p>
                    <div>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1 mb-2" disabled *ngIf="previewData['ambulatoryIndependent']">
                            {{ 'ADD_STUDENT.PART_B.AMBULATORY_INDEPENDENT' | translate }}
                        </button>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1 mb-2" disabled *ngIf="previewData['ambulatoryAssistanceNeeded']">
                            {{ 'ADD_STUDENT.PART_B.AMBULATORY_ASSISTANCE_NEEDED' | translate }}
                        </button>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1 mb-2" disabled *ngIf="previewData['ambulatoryUnaided']">
                            {{ 'ADD_STUDENT.PART_B.AMBULATORY_UNAIDED' | translate }}
                        </button>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1 mb-2" disabled *ngIf="previewData['ambulatoryCrutches']">
                            {{ 'ADD_STUDENT.PART_B.AMBULATORY_CRUTCHES' | translate }}
                        </button>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1 mb-2" disabled *ngIf="previewData['ambulatoryWalkingStick']">
                            {{ 'ADD_STUDENT.PART_B.AMBULATORY_WALKING_STICK' | translate }}
                        </button>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1 mb-2" disabled *ngIf="previewData['ambulatoryWalker']">
                            {{ 'ADD_STUDENT.PART_B.AMBULATORY_WALKER' | translate }}
                        </button>
                    </div>
                </div>
                <div class="row gx-0" *ngIf="previewData['ambulatory_other']">
                    <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.AMBULATORY_OTHER' | translate }}：{{ previewData['ambulatory_other'] }}</div>
                </div>
            </div>
            <!-- <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.NON_AMBULATORY_SECTION_TITLE' | translate }}：{{ previewData['nonAmbulatoryChoice'] }}</div>
            </div> -->
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ 'ADD_STUDENT.PART_B.NON_AMBULATORY_SECTION_TITLE' | translate }}
                    {{
                        (previewData['nonAmbulatoryChoice'] === 'wheelchair_non_ambulatory' ? ('ADD_STUDENT.PART_B.NON_AMBULATORY_WHEELCHAIR' | translate) :
                        (previewData['nonAmbulatoryChoice'] === 'wheelchair_ambulatory_with_assistance' ? ('ADD_STUDENT.PART_B.NON_AMBULATORY_WHEELCHAIR_ASSISTED' | translate) :
                        (previewData['nonAmbulatoryChoice'] === 'other' ? (('ADD_STUDENT.PART_B.AMBULATORY_OTHER' | translate) + (previewData['non_ambulatory_other'] ? ' (' + previewData['non_ambulatory_other'] + ')' : '')) : '')))
                    }}
                </div>
            </div>
            <!-- <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.PARTS_AFFECTED_SECTION_TITLE' | translate }}：{{ previewData['part_body_affected'] }}</div>
            </div> -->
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.PARTS_AFFECTED_SECTION_TITLE' | translate }}
                  {{ 
                    (previewData['part_body_affected'] === 'right' ? ('ADD_STUDENT.PART_B.PARTS_AFFECTED_RIGHT' | translate) :
                    (previewData['part_body_affected'] === 'left' ? ('ADD_STUDENT.PART_B.PARTS_AFFECTED_LEFT' | translate) :
                    (previewData['part_body_affected'] === 'upper_body' ? ('ADD_STUDENT.PART_B.PARTS_AFFECTED_UPPER_BODY' | translate) :
                    (previewData['part_body_affected'] === 'lower_body' ? ('ADD_STUDENT.PART_B.PARTS_AFFECTED_LOWER_BODY' | translate) : ''))))
                  }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.PROSTHESIS_ORTHOSIS_LABEL' | translate }}：{{ previewData['prosthesis'] }}</div>
            </div>
            <!-- <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.HEAD_CONTROL_TITLE' | translate }}：{{ previewData['head_control'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.TRUNK_CONTROL_TITLE' | translate }}：{{ previewData['trunk_control'] }}</div>
            </div> -->
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.HEAD_CONTROL_TITLE' | translate }}：
                  {{ 
                    (previewData['head_control'] === 'Good' ? ('ADD_STUDENT.PART_B.HEAD_CONTROL_GOOD' | translate) :
                    (previewData['head_control'] === 'Fair' ? ('ADD_STUDENT.PART_B.HEAD_CONTROL_FAIR' | translate) :
                    (previewData['head_control'] === 'Poor' ? ('ADD_STUDENT.PART_B.HEAD_CONTROL_POOR' | translate) :
                    (previewData['head_control'] === 'No control' ? ('ADD_STUDENT.PART_B.HEAD_CONTROL_NO_CONTROL' | translate) : ''))))
                  }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_B.TRUNK_CONTROL_TITLE' | translate }}：
                  {{ 
                    (previewData['trunk_control'] === 'Good' ? ('ADD_STUDENT.PART_B.TRUNK_CONTROL_GOOD' | translate) :
                    (previewData['trunk_control'] === 'Fair' ? ('ADD_STUDENT.PART_B.TRUNK_CONTROL_FAIR' | translate) :
                    (previewData['trunk_control'] === 'Poor' ? ('ADD_STUDENT.PART_B.TRUNK_CONTROL_POOR' | translate) :
                    (previewData['trunk_control'] === 'No control' ? ('ADD_STUDENT.PART_B.TRUNK_CONTROL_NO_CONTROL' | translate) : ''))))
                  }}
                </div>
            </div>
            <div class="mt-3 text-center mb-2" id="">
                {{ 'ADD_STUDENT.PART_C.GUARDIAN_CONSENT_TITLE' | translate }}
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['riderInfoConsent'] ? previewData['consentLabels'].fixedPrefix : previewData['consentLabels'].DISAGREEPREFIX }}{{ previewData['consentLabels'].riderInfoConsent }}
                </div>
            </div>
            <!-- <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['rehabReleaseConsent'] ? previewData['consentLabels'].fixedPrefix : previewData['consentLabels'].DISAGREEPREFIX }}{{ previewData['consentLabels'].rehabReleaseConsent }}
                </div>
            </div> -->
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['photoVideoConsent'] ? previewData['consentLabels'].fixedPrefix : previewData['consentLabels'].DISAGREEPREFIX }}{{ previewData['consentLabels'].photoVideoConsent }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['rdaLessonArrangementConsent'] ? previewData['consentLabels'].fixedPrefix : previewData['consentLabels'].DISAGREEPREFIX }}{{ previewData['consentLabels'].rdaLessonArrangementConsent }}
                </div>
            </div>
            <!-- <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}：{{ previewData['riderInfoConsent'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}：{{ previewData['rehabReleaseConsent'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}：{{ previewData['photoVideoConsent'] }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}：{{ previewData['rdaLessonArrangementConsent'] }}</div>
            </div> -->
            <div class="mt-3 text-center mb-2" id="">
                {{ 'ADD_STUDENT.PART_D.GUARDIAN_DOCUMENT_TITLE' | translate }}
            </div>

            <!-- <div class="row gx-0">
                <div class="col-sm-12">{{previewData['consentLabels'].medical_epilepsy }}：{{ previewData['statement_rider_medical_condition'].name }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ previewData['consentLabels'].medical_downs }}：{{ previewData['medical_certificate_down_syndrome'].name }}</div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">{{ previewData['consentLabels'].medical_heart_}}：{{ previewData['medical_certificate_heart_disease'].name }}</div>
            </div> -->
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{previewData['consentLabels'].medical_epilepsy }}：
                    {{ previewData['statement_rider_medical_condition']?.name || '' }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['consentLabels'].medical_downs }}：
                    {{ previewData['medical_certificate_down_syndrome']?.name || '' }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['consentLabels'].medical_heart_}}：
                    {{ previewData['medical_certificate_heart_disease']?.name || '' }}
                </div>
            </div>
            <div class="row gx-0">
                <div class="col-sm-12">
                    {{ previewData['consentLabels'].rehabReleaseConsent}}：
                    {{ previewData['statement_release_indemnity']?.name || '' }}
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onCancel()">
                {{ 'ADD_STUDENT.PREVIEW.CANCEL_BUTTON' | translate }}
            </button>
            <button type="button" class="btn button-primary-purple btn-sm" (click)="onConfirmSubmit()">
                {{ 'ADD_STUDENT.PREVIEW.CONFIRM_BUTTON' | translate }}
            </button>
        </div>

    </div>
</div>